import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { LogoFull } from "./Logo";

const seen = typeof window !== "undefined" && sessionStorage.getItem("lf-intro") === "1";
export const INTRO_DELAY = seen ? 0 : 1.5;

export const Preloader = () => {
  const [show, setShow] = useState(!seen);
  useEffect(() => {
    if (!show) return undefined;
    sessionStorage.setItem("lf-intro", "1");
    const t = setTimeout(() => setShow(false), 1500);
    return () => clearTimeout(t);
  }, [show]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="preloader"
          className="fixed inset-0 z-[100] flex items-center justify-center bg-[#141210]"
          exit={{ clipPath: "inset(0 0 100% 0)" }}
          transition={{ duration: 1, ease: [0.76, 0, 0.24, 1] }}
        >
          <motion.div
            initial={{ opacity: 0, scale: 0.92, filter: "blur(8px)" }}
            animate={{ opacity: 1, scale: 1, filter: "blur(0px)" }}
            transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
          >
            <LogoFull className="h-44 w-auto sm:h-56" />
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
